import React, { useState } from "react";
import "./expandedComponent.scss";
import parse from "html-react-parser";
import dummy from "../../../../../assets/images/dummyBg.png"
import ExpandedModal from "../../../../shared/subpageImageCircle/expandedModal/ExpandedModal";
import CustomTooltip from "../../../../shared/tooltip/CustomTooltip";
const ExpandedComponent = ({ item }) => {
  const handleOnError = (e) => {
    e.target.src = dummy;
  };
  const [screen, setScreen] = useState({
    show: false,
  });
  return (
    <>
      <div className="expandedComponentHolder">
        <div className="topSection" onClick={() => setScreen(() => ({ ...screen, show: true }))}>
          {item.image && (
            <CustomTooltip title={(item.picturesCount >= 0 || item.videosCount > 0) ? "Click to view gallery" : "View image"} position="bottom">
              <img onError={handleOnError}
                src={process.env.REACT_APP_BACKEND_URL + "public/" + item.image}
                className="topImage"
              />
            </CustomTooltip>
          )}
          <div className="yellowSection px-4 space-between">
            <p className="mb-0 imageCount">
              {item.picturesCount >= 0 && item.picturesCount + 1 + ' Photo(s)'}
              {item.videosCount > 0 && ", " + item.videosCount + " Video(s)"}
            </p>
            <p className="mb-0">
              {item.date && item.date.formattedDate}
            </p>

          </div>
        </div>

        {item.description && (
          <div className="bottomSection">
            <h5 className="detailsTitle">{item.title}</h5>
            {item.description && (
              <p className="details mb-0"> {parse(item.description)}</p>
            )}
          </div>
        )}
      </div>
      <ExpandedModal
        show={screen.show}
        onHide={() => setScreen(() => ({ ...screen, show: false }))}
        url={`news-events/${item._id}`}
        module={item.picturesCount >= 0 || item.videosCount > 0 ? "" : "news-events"}
        array={[item]}

      />
    </>

  );
};

export default ExpandedComponent;
